import { Box } from '@mui/material';
import type { ReactNode } from 'react';

const MARKETING_STATION_VIOLET_GRADIENT = 'linear-gradient(to bottom, #DBD7FF 0%, #F7F5F2 25%)';

interface MarketingStationLayoutProps {
  children: ReactNode;
  className?: string;
}

export default function MarketingStationLayout({
  children,
  className = 'grow flex flex-col px-20 py-16 gap-16 overflow-hidden',
}: MarketingStationLayoutProps): JSX.Element {
  return (
    <Box className={className} style={{ background: MARKETING_STATION_VIOLET_GRADIENT }}>
      {children}
    </Box>
  );
}

export { MARKETING_STATION_VIOLET_GRADIENT };
